<script setup lang="ts">
/* A status strip. Shell layouts place it at the foot of their content column
 * (beside the sidebar); app.vue pins it full-width on full-screen pages. */
const { chat, open } = useUserAgentChat()
const { connectionState, connectionError } = useUserAgent()
const busy = computed(
  () => chat.status === 'submitted' || chat.status === 'streaming',
)
</script>

<template>
  <footer
    class="border-default bg-default flex h-8 shrink-0 items-center justify-end border-t px-4"
  >
    <AiConnectionStatus
      v-if="connectionState !== 'connected'"
      class="mr-2"
      :connection-error="connectionError"
      :connection-state="connectionState"
    />
    <UTooltip :kbds="['meta', 'J']" text="Agent">
      <UButton
        :aria-expanded="open"
        :icon="busy ? 'i-ph-circle-notch' : 'i-ph-sparkle'"
        :ui="{ leadingIcon: busy ? 'animate-spin' : '' }"
        :variant="open ? 'soft' : 'ghost'"
        aria-controls="agent-chat"
        color="neutral"
        label="Agent"
        size="xs"
        @click="open = !open"
      />
    </UTooltip>
  </footer>
</template>
